import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import { pageTitle } from 'app/features/success/selectors';

const UI = ({ pageTitle }) => (
  <FormattedMessage id={pageTitle}>
    {([title]) => <Helmet title={title} />}
  </FormattedMessage>
);

UI.propTypes = {
  pageTitle: PropTypes.string.isRequired,
};

UI.displayName = 'MetaTitle';

const MetaTitle = connect({ pageTitle })(UI);

export { UI };

export default MetaTitle;
